
import { Component, Input, OnInit } from '@angular/core';
import { PtlNotificationService, PtlNotificationStyle, PtlWindowLocationService } from '@ptl/global-components';
import { PRODUCER_URL_PARAM_KEYS } from './services/passive-referral-loader.service';
import { savePassiveReferrals } from './reducers/passive-referral-loader.reducer';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';
// import * as moment from 'moment';
import moment from 'moment';

@Component({
    selector: 'app-passive-referral-loader',
    templateUrl: './passive-referral-loader.component.html',
    styleUrls: ['./passive-referral-loader.component.scss'],
    standalone: false
})
export class PassiveReferralLoaderComponent implements OnInit {

  
  @Input() isSep: string | boolean;
  @Input() sepRedirectUrl: string;
  @Input() oepRedirectUrl: string; 
  @Input() loadingMessage: string; 
  @Input() planYear: string;

  @Input() expiredLinkUrl: string = '/expired-purl-link';

  url: URL = new URL(window.location.href);
  params: URLSearchParams = this.url.searchParams;
  redirectUrl: string; 
  
  constructor(
    private windowService: PtlWindowLocationService,
    private ptlNotificationService: PtlNotificationService,
    private ngRedux: NgRedux<StateStructure>,
  ) { }

  async ngOnInit() {

    this.loadPlanSession();
  }

  async loadPlanSession() {

    if (this.isSep === "true") {
      this.isSep = true;
    } else {
      this.isSep = false;
    }

    let agentName = this.params.get(PRODUCER_URL_PARAM_KEYS.AGENT_NAME)?.split("_").join(" ");
    let agentCode = this.params.get(PRODUCER_URL_PARAM_KEYS.AGENT_CODE);
    let agencyNumber = this.params.get(PRODUCER_URL_PARAM_KEYS.AGENCY_NUMBER);
    let year = this.params.get(PRODUCER_URL_PARAM_KEYS.YEAR);
    let curBrandCode = this.params.get(PRODUCER_URL_PARAM_KEYS.BRAND_NAME);
    let userId = this.params.get(PRODUCER_URL_PARAM_KEYS.USER_ID); 
    let emailTypePreference = this.params.get(PRODUCER_URL_PARAM_KEYS.EMAIL_TYPE_PREFERENCE);
    this.redirectUrl = this.isSep ? this.sepRedirectUrl : this.oepRedirectUrl;

    // validate query params
    if (!agentName || !agentCode || !agencyNumber || !year || !curBrandCode || !userId || !emailTypePreference) {
      console.error("Invalid query parameters supplied. agentCode, agencyNumber, year, curBrandCode, userId, and emailTypePreference are required");
      this.showError()
      return;
    }


    const linkYear = year;
    // moment().month() has a value of 0-11, 0 being January, 11 being December
    // the plan year will default to the current year if the month is BEFORE July. Any month that is July or later will default to the following plan year. 
    // ex: June 2025, Plan Year: 2025 | July 2025, Plan Year: 2026
    const defaultPlanYear = moment().month() > 5 ? moment().year() + 1 : moment().year();
    const currentPlanYear = this.planYear ? this.planYear : String(defaultPlanYear);


    if(linkYear !== currentPlanYear){
      this.windowService.goToUrl(this.expiredLinkUrl);
    }else{

    this.ngRedux.dispatch(savePassiveReferrals(agentName, agentCode, agencyNumber, year, curBrandCode, userId, emailTypePreference))
      // If everything worked, redirect the user
    this.windowService.goToUrl(this.redirectUrl);
    }
    
  }

  showError() {
    this.ptlNotificationService.open({
      title: 'Error Loading Information',
      content: 'We couldn\'t load your specific plan information. You will now be taken to our full list of plans.',
      primaryButtonText: 'OK',
      notificationStyle: PtlNotificationStyle.DANGER,
    })
      .afterClosed().subscribe(() => this.windowService.goToUrl(this.redirectUrl));
  }

}


